import type { RouteRecordRaw } from "vue-router";

// Auth-only routes — inside the auth shell (requiresAuth inherited from parent).
// The UX is a timeline feed + side drawer (not list/edit CRUD), so these are
// hand-written rather than generated via crudRoutes.
//
// `meta.moduleKey` ('expense_tracker') gates these on the Financial Obligations
// module grant in the router guard — so an emailed deep link from a user whose
// grant was revoked lands on the dashboard instead of a shell that only 403s
// from the API. Mirrors the backend `require_module("Expense Tracker")` gate.
export const expenseTrackerRoutes: RouteRecordRaw[] = [
  {
    path: "/expense-tracker",
    name: "expense-tracker",
    component: () => import("@/views/ExpenseTracker/ExpenseTrackerHome.vue"),
    meta: { moduleKey: "expense_tracker" },
  },
  {
    path: "/expense-tracker/new",
    name: "expense-tracker-new",
    component: () => import("@/views/ExpenseTracker/ExpenseForm.vue"),
    meta: { moduleKey: "expense_tracker" },
  },
  {
    // Edit is restricted to the latest submission (enforced server-side); the
    // home view only exposes the button on the current row.
    path: "/expense-tracker/:id(\\d+)/edit",
    name: "expense-tracker-edit",
    component: () => import("@/views/ExpenseTracker/ExpenseForm.vue"),
    meta: { moduleKey: "expense_tracker" },
  },
];
